import React from "react";
import { Search } from "lucide-react";
import { highlightText } from "../../utils/textAnalysis";

const SearchTab = ({
  searchQuery,
  highlightWord,
  searchResults,
  songs,
  stats,
  onSongSelect,
  darkMode,
}) => {
  return (
    <div>
      {searchQuery || highlightWord ? (
        <div>
          <div className="mb-4 text-sm text-forest-300">
            Found{" "}
            {searchResults.reduce(
              (total, result) => total + result.matchCount,
              0,
            )}{" "}
            matches in {searchResults.length} verse
            {searchResults.length !== 1 ? "s" : ""} for "
            {searchQuery || highlightWord}"
            {highlightWord && !searchQuery && (
              <span className="ml-2 text-xs text-forest-400">
                (highlighted from other tabs)
              </span>
            )}
          </div>

          <div className="space-y-4">
            {searchResults.map((result, index) => (
              <div
                key={index}
                className="rounded-lg border p-4 transition-colors bg-forest-800 border-forest-600 card-glow"
              >
                <div className="flex items-center justify-between mb-3">
                  <h3 className="font-medium text-forest-100">
                    {result.songTitle}
                  </h3>
                  <div className="flex items-center gap-3">
                    <span className="text-xs px-2 py-1 rounded bg-forest-700 text-forest-200">
                      {result.matchCount} match
                      {result.matchCount !== 1 ? "es" : ""}
                    </span>
                    <span className="text-xs text-forest-300">
                      Verse {result.verseIndex} • Line {result.lineNumber}
                    </span>
                  </div>
                </div>

                <div className="text-sm leading-relaxed whitespace-pre-line text-forest-200">
                  {highlightText(
                    result.verseContent,
                    searchQuery || highlightWord,
                    result.isExactMatch,
                  )}
                </div>

                <button
                  onClick={() =>
                    onSongSelect(songs.find((s) => s.id === result.songId))
                  }
                  className="mt-3 text-xs underline transition-colors text-forest-300 hover:text-forest-200"
                >
                  View full song
                </button>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center py-12">
          <Search className="w-16 h-16 mx-auto mb-4 text-forest-600" />
          <h3 className="text-lg font-medium mb-2 text-forest-100">
            Start searching your lyrics
          </h3>
          <p className="mb-6 text-forest-300">
            Enter any word or phrase to find where you've used it before
          </p>

          {songs.length > 0 && (
            <div className="rounded-lg border p-4 max-w-md mx-auto transition-colors bg-forest-800 border-forest-600">
              <div className="text-sm space-y-1 text-forest-300">
                <div>{stats.totalSongs} songs loaded</div>
                <div>{stats.totalWords.toLocaleString()} total words</div>
                <div>{stats.uniqueWords.toLocaleString()} unique words</div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchTab;
